type WahlkreisData = {
  [key: string]: {
    firstname: string
    lastname: string
  }
}

const wahlkreisData: WahlkreisData = {
  wk1: {
    firstname: 'Johanna',
    lastname: 'Selbert',
  },
  wk2: {
    firstname: 'Truels',
    lastname: 'Reichardt',
  },
  wk3: {
    firstname: 'Hauke',
    lastname: 'Thießen',
  },
  wk4: {
    firstname: 'Felix',
    lastname: 'Wilsberg',
  },
  wk5: {
    firstname: 'Christina',
    lastname: 'Schubert',
  },
  wk6: {
    firstname: 'Kristian',
    lastname: 'Klinck',
  },
  wk7: {
    firstname: 'Dr. Ralf',
    lastname: 'Stegner',
  },
  wk8: {
    firstname: 'Bengt',
    lastname: 'Bergt',
  },
  wk9: {
    firstname: 'Bettina',
    lastname: 'Hagedorn',
  },
  wk10: {
    firstname: 'Dr. Nina',
    lastname: 'Scheer',
  },
  wk11: {
    firstname: 'Tim',
    lastname: 'Klüssendorf',
  },
  wk12: {
    firstname: 'Reem',
    lastname: 'Alabali-Radovan',
  },
  wk13: {
    firstname: 'Frank',
    lastname: 'Junge',
  },
  wk14: {
    firstname: 'Katrin',
    lastname: 'Zschau',
  },
  wk15: {
    firstname: 'Anna',
    lastname: 'Kassautzki',
  },
  wk16: {
    firstname: 'Erik',
    lastname: 'von Malottki',
  },
  wk17: {
    firstname: 'Johannes',
    lastname: 'Arlt',
  },
  wk18: {
    firstname: 'Falko',
    lastname: 'Droßmann',
  },
  wk19: {
    firstname: 'Sören',
    lastname: 'Platten',
  },
  wk20: {
    firstname: 'Wolfgang',
    lastname: 'Schmidt',
  },
  wk21: {
    firstname: 'Dorothee',
    lastname: 'Martin',
  },
  wk22: {
    firstname: 'Aydan',
    lastname: 'Özoğuz',
  },
  wk23: {
    firstname: 'Metin',
    lastname: 'Hakverdi',
  },
  wk24: {
    firstname: 'Johann',
    lastname: 'Saathoff',
  },
  wk25: {
    firstname: 'Anja',
    lastname: 'Troff-Schaffarzyk',
  },
  wk26: {
    firstname: 'Siemtje',
    lastname: 'Möller',
  },
  wk27: {
    firstname: 'Dennis',
    lastname: 'Rohde',
  },
  wk28: {
    firstname: 'Hamza',
    lastname: 'Atilgan',
  },
  wk29: {
    firstname: 'Daniel',
    lastname: 'Schneider',
  },
  wk30: {
    firstname: 'Frauke',
    lastname: 'Langen',
  },
  wk31: {
    firstname: 'Dr. Daniela',
    lastname: 'De Ridder',
  },
  wk32: {
    firstname: 'Alexander',
    lastname: 'Bartz',
  },
  wk33: {
    firstname: 'Peggy',
    lastname: 'Schierenbeck',
  },
  wk34: {
    firstname: 'Özge',
    lastname: 'Kadah',
  },
  wk35: {
    firstname: 'Lars',
    lastname: 'Klingbeil',
  },
  wk36: {
    firstname: 'Svenja',
    lastname: 'Stadler',
  },
  wk37: {
    firstname: 'Jakob',
    lastname: 'Blankenburg',
  },
  wk38: {
    firstname: 'Anke',
    lastname: 'Hennig',
  },
  wk39: {
    firstname: 'Thomas',
    lastname: 'Vaupel',
  },
  wk40: {
    firstname: 'Marja-Liisa',
    lastname: 'Völlers',
  },
  wk41: {
    firstname: 'Adis',
    lastname: 'Ahmetovic',
  },
  wk42: {
    firstname: 'Boris',
    lastname: 'Pistorius',
  },
  wk43: {
    firstname: 'Rebecca',
    lastname: 'Schamber',
  },
  wk44: {
    firstname: 'Angela',
    lastname: 'Hohmann',
  },
  wk45: {
    firstname: 'Hubertus',
    lastname: 'Heil',
  },
  wk46: {
    firstname: 'Johannes',
    lastname: 'Schraps',
  },
  wk47: {
    firstname: 'Dr. Matthias',
    lastname: 'Miersch',
  },
  wk48: {
    firstname: 'Daniela',
    lastname: 'Rump',
  },
  wk49: {
    firstname: 'Dunja',
    lastname: 'Kreiser',
  },
  wk50: {
    firstname: 'Dr. Christos',
    lastname: 'Pantazis',
  },
  wk51: {
    firstname: 'Benjamin',
    lastname: 'Stern',
  },
  wk52: {
    firstname: 'Frauke',
    lastname: 'Heiligenstadt',
  },
  wk53: {
    firstname: 'Dr. Thorsten',
    lastname: 'Heinze',
  },
  wk54: {
    firstname: 'Ulrike',
    lastname: 'Hiller',
  },
  wk56: {
    firstname: 'Wiebke',
    lastname: 'Papenbrock',
  },
  wk57: {
    firstname: 'Stefan',
    lastname: 'Zierke',
  },
  wk58: {
    firstname: 'Ariane',
    lastname: 'Fäscher',
  },
  wk59: {
    firstname: 'Simona',
    lastname: 'Koß',
  },
  wk60: {
    firstname: 'Sonja',
    lastname: 'Eichwede',
  },
  wk61: {
    firstname: 'Olaf',
    lastname: 'Scholz',
  },
  wk62: {
    firstname: 'Anja',
    lastname: 'Soheam',
  },
  wk63: {
    firstname: 'Mathias',
    lastname: 'Papendieck',
  },
  wk64: {
    firstname: 'Maja',
    lastname: 'Wallstein',
  },
  wk65: {
    firstname: 'Hannes',
    lastname: 'Walter',
  },
  wk66: {
    firstname: 'Dr. Herbert',
    lastname: 'Wollmann',
  },
  wk67: {
    firstname: 'Franziska',
    lastname: 'Kersten',
  },
  wk68: {
    firstname: 'Florian',
    lastname: 'Fahrtmann',
  },
  wk69: {
    firstname: 'Martin',
    lastname: 'Kröber',
  },
  wk70: {
    firstname: 'Diana',
    lastname: 'Bäse',
  },
  wk72: {
    firstname: 'Norman',
    lastname: 'Steigleder',
  },
  wk73: {
    firstname: 'Aick',
    lastname: 'Pietschmann',
  },
  wk74: {
    firstname: 'Annika',
    lastname: 'Klose',
  },
  wk75: {
    firstname: 'Alexandra',
    lastname: 'Wend',
  },
  wk76: {
    firstname: 'Julian',
    lastname: 'Holter',
  },
  wk78: {
    firstname: 'Ruppert',
    lastname: 'Stüwe',
  },
  wk79: {
    firstname: 'Michael',
    lastname: 'Müller',
  },
  wk80: {
    firstname: 'Sinem',
    lastname: 'Taşan-Funke',
  },
  wk81: {
    firstname: 'Hakan',
    lastname: 'Demir',
  },
  wk82: {
    firstname: 'Carmen',
    lastname: 'Sinnokrot',
  },
  wk83: {
    firstname: 'Ana-Maria',
    lastname: 'Trăsnea',
  },
  wk84: {
    firstname: 'Ben',
    lastname: 'Schneider',
  },
  wk85: {
    firstname: 'Jan',
    lastname: 'Zimmerling',
  },
  wk86: {
    firstname: 'Ye-One',
    lastname: 'Rhie',
  },
  wk87: {
    firstname: 'Claudia',
    lastname: 'Moll',
  },
  wk88: {
    firstname: 'Christoph',
    lastname: 'Nießen',
  },
  wk89: {
    firstname: 'Daniel',
    lastname: 'Walter',
  },
  wk90: {
    firstname: 'Aaron',
    lastname: 'Spielmanns',
  },
  wk91: {
    firstname: 'Andrea',
    lastname: 'Kanonenberg',
  },
  wk92: {
    firstname: 'Sanae',
    lastname: 'Abdi',
  },
  wk93: {
    firstname: 'Renan',
    lastname: 'Demirkan',
  },
  wk94: {
    firstname: 'Rolf',
    lastname: 'Mützenich',
  },
  wk95: {
    firstname: 'Jessica',
    lastname: 'Rosenthal',
  },
  wk96: {
    firstname: 'Sebastian',
    lastname: 'Hartmann',
  },
  wk97: {
    firstname: 'Ute',
    lastname: 'Krupp',
  },
  wk98: {
    firstname: 'Pascal',
    lastname: 'Reinhardt',
  },
  wk99: {
    firstname: 'Hinrich',
    lastname: 'Schipper',
  },
  wk100: {
    firstname: 'Karl',
    lastname: 'Lauterbach',
  },
  wk101: {
    firstname: 'Helge',
    lastname: 'Lindh',
  },
  wk102: {
    firstname: 'Ingo',
    lastname: 'Schäfer',
  },
  wk103: {
    firstname: 'Pat',
    lastname: 'Kreß',
  },
  wk104: {
    firstname: 'Kerstin',
    lastname: 'Griese',
  },
  wk105: {
    firstname: 'Zanda',
    lastname: 'Martens',
  },
  wk106: {
    firstname: 'Adis',
    lastname: 'Selimi',
  },
  wk107: {
    firstname: 'Daniel',
    lastname: 'Rinkert',
  },
  wk108: {
    firstname: 'Gülistan',
    lastname: 'Yüksel',
  },
  wk109: {
    firstname: 'Ina',
    lastname: 'Spanier-Oppermann',
  },
  wk110: {
    firstname: 'Silke',
    lastname: 'Depta',
  },
  wk111: {
    firstname: 'Bodo',
    lastname: 'Wißen',
  },
  wk112: {
    firstname: 'Kevin',
    lastname: 'Waldeck',
  },
  wk113: {
    firstname: 'Jan',
    lastname: 'Dieren',
  },
  wk114: {
    firstname: 'Bärbel',
    lastname: 'Bas',
  },
  wk115: {
    firstname: 'Mahmut',
    lastname: 'Özdemir',
  },
  wk116: {
    firstname: 'Dirk',
    lastname: 'Vöpel',
  },
  wk117: {
    firstname: 'Sebastian',
    lastname: 'Fiedler',
  },
  wk118: {
    firstname: 'Ingo',
    lastname: 'Vogel',
  },
  wk119: {
    firstname: 'Albert',
    lastname: 'Ritter',
  },
  wk120: {
    firstname: 'Frank',
    lastname: 'Schwabe',
  },
  wk121: {
    firstname: 'Brian',
    lastname: 'Nickholz',
  },
  wk122: {
    firstname: 'Markus',
    lastname: 'Toens',
  },
  wk123: {
    firstname: 'Sarah',
    lastname: 'Lahrkamp',
  },
  wk124: {
    firstname: 'Dustin',
    lastname: 'Tix',
  },
  wk125: {
    firstname: 'Nadine',
    lastname: 'Heselhaus',
  },
  wk126: {
    firstname: 'Johannes',
    lastname: 'Waldmann',
  },
  wk127: {
    firstname: 'Jürgen',
    lastname: 'Coße',
  },
  wk128: {
    firstname: 'Svenja',
    lastname: 'Schulze',
  },
  wk129: {
    firstname: 'Dennis',
    lastname: 'Kocker',
  },
  wk130: {
    firstname: 'Elvan',
    lastname: 'Korkmaz-Emre',
  },
  wk131: {
    firstname: 'Wiebke',
    lastname: 'Esdar',
  },
  wk132: {
    firstname: 'Stefan',
    lastname: 'Schwartze',
  },
  wk133: {
    firstname: 'Fabian',
    lastname: 'Golanowsky',
  },
  wk134: {
    firstname: 'Julien',
    lastname: 'Thiede',
  },
  wk135: {
    firstname: 'Katrin',
    lastname: 'Freiberger',
  },
  wk136: {
    firstname: 'Burkhard',
    lastname: 'Blienert',
  },
  wk137: {
    firstname: 'Timo',
    lastname: 'Schisanowski',
  },
  wk138: {
    firstname: 'Axel',
    lastname: 'Echeverria',
  },
  wk139: {
    firstname: 'Serdar',
    lastname: 'Yüksel',
  },
  wk140: {
    firstname: 'Hendrik',
    lastname: 'Bollmann',
  },
  wk141: {
    firstname: 'Jens',
    lastname: 'Peick',
  },
  wk142: {
    firstname: 'Sabine',
    lastname: 'Poschmann',
  },
  wk143: {
    firstname: 'Oliver',
    lastname: 'Kaczmarek',
  },
  wk144: {
    firstname: 'Michael',
    lastname: 'Thews',
  },
  wk145: {
    firstname: 'Jens',
    lastname: 'Behrens',
  },
  wk146: {
    firstname: 'Dirk',
    lastname: 'Wiese',
  },
  wk147: {
    firstname: 'Luiza',
    lastname: 'Licina-Bode',
  },
  wk148: {
    firstname: 'Nezahat',
    lastname: 'Baradari',
  },
  wk150: {
    firstname: 'Heiko',
    lastname: 'Wittig',
  },
  wk151: {
    firstname: 'Holger',
    lastname: 'Mann',
  },
  wk152: {
    firstname: 'Nadja',
    lastname: 'Sthamer',
  },
  wk153: {
    firstname: 'Franziska',
    lastname: 'Mascheck',
  },
  wk154: {
    firstname: 'Leonhard',
    lastname: 'Weist',
  },
  wk155: {
    firstname: 'Kathrin',
    lastname: 'Michel',
  },
  wk156: {
    firstname: 'Harald',
    lastname: 'Prause-Kosubek',
  },
  wk157: {
    firstname: 'Fabian',
    lastname: 'Funke',
  },
  wk158: {
    firstname: 'Rasha',
    lastname: 'Nasr',
  },
  wk159: {
    firstname: 'Stephan',
    lastname: 'Schumann',
  },
  wk160: {
    firstname: 'Dr. Ralf',
    lastname: 'Walper',
  },
  wk161: {
    firstname: 'Detlef',
    lastname: 'Müller',
  },
  wk162: {
    firstname: 'Carlos',
    lastname: 'Kasper',
  },
  wk163: {
    firstname: 'Dr. Silvio',
    lastname: 'Heider',
  },
  wk164: {
    firstname: 'Jens',
    lastname: 'Juraschka',
  },
  wk165: {
    firstname: 'Maik',
    lastname: 'Linke',
  },
  wk166: {
    firstname: 'Esther',
    lastname: 'Dilcher',
  },
  wk167: {
    firstname: 'Daniel',
    lastname: 'Bettermann',
  },
  wk170: {
    firstname: 'Sören',
    lastname: 'Bartol',
  },
  wk171: {
    firstname: 'Dagmar',
    lastname: 'Schmidt',
  },
  wk172: {
    firstname: 'Felix',
    lastname: 'Döring',
  },
  wk173: {
    firstname: 'Christine',
    lastname: 'Fischer',
  },
  wk174: {
    firstname: 'Michael',
    lastname: 'Neuner',
  },
  wk175: {
    firstname: 'David',
    lastname: 'Wade',
  },
  wk176: {
    firstname: 'Natalie',
    lastname: 'Pawlik',
  },
  wk177: {
    firstname: 'Martin',
    lastname: 'Rabanus',
  },
  wk178: {
    firstname: 'Nadine',
    lastname: 'Ruf',
  },
  wk179: {
    firstname: 'Lennard',
    lastname: 'Oehl',
  },
  wk180: {
    firstname: 'Nancy',
    lastname: 'Faeser',
  },
  wk181: {
    firstname: 'Armand',
    lastname: 'Zorn',
  },
  wk182: {
    firstname: 'Lena',
    lastname: 'Voigt',
  },
  wk183: {
    firstname: 'Melanie',
    lastname: 'Wegling',
  },
  wk184: {
    firstname: 'Helena',
    lastname: 'Wolf',
  },
  wk186: {
    firstname: 'Jens',
    lastname: 'Zimmermann',
  },
  wk187: {
    firstname: 'Sven',
    lastname: 'Wingerter',
  },
  wk188: {
    firstname: 'Mohamed',
    lastname: 'Sayed',
  },
  wk189: {
    firstname: 'Tina',
    lastname: 'Rudolph',
  },
  wk190: {
    firstname: 'Dr. Holger',
    lastname: 'Becker',
  },
  wk191: {
    firstname: 'Florian',
    lastname: 'Wagner',
  },
  wk192: {
    firstname: 'Carsten',
    lastname: 'Schneider',
  },
  wk193: {
    firstname: 'Elisabeth',
    lastname: 'Kaiser',
  },
  wk194: {
    firstname: 'Bastian',
    lastname: 'Dohna',
  },
  wk195: {
    firstname: 'Raimund',
    lastname: 'Meß',
  },
  wk196: {
    firstname: 'Jan',
    lastname: 'Hellinghausen',
  },
  wk197: {
    firstname: 'Dr. Ferdi',
    lastname: 'Akaltin',
  },
  wk198: {
    firstname: 'Dr. Thorsten',
    lastname: 'Rudolph',
  },
  wk199: {
    firstname: 'Umut',
    lastname: 'Kurt',
  },
  wk202: {
    firstname: 'Verena',
    lastname: 'Hubertz',
  },
  wk203: {
    firstname: 'Dr. Tanja',
    lastname: 'Machalet',
  },
  wk204: {
    firstname: 'Daniel',
    lastname: 'Baldy',
  },
  wk205: {
    firstname: 'Markus',
    lastname: 'Trapp',
  },
  wk206: {
    firstname: 'Christian',
    lastname: 'Schreider',
  },
  wk207: {
    firstname: 'Isabel',
    lastname: 'Mackensen-Geis',
  },
  wk208: {
    firstname: 'Matthias',
    lastname: 'Mieves',
  },
  wk209: {
    firstname: 'Angelika',
    lastname: 'Glöckner',
  },
  wk210: {
    firstname: 'Yildiz',
    lastname: 'Härtel',
  },
  wk211: {
    firstname: 'Jürgen',
    lastname: 'Fernengel',
  },
  wk212: {
    firstname: 'Dr. Mohr',
    lastname: 'Marco',
  },
  wk213: {
    firstname: 'Andreas',
    lastname: 'Mehltretter',
  },
  wk214: {
    firstname: 'Michael',
    lastname: 'Schrodi',
  },
  wk215: {
    firstname: 'Nadine',
    lastname: 'Praun',
  },
  wk216: {
    firstname: 'Philippa',
    lastname: 'Sigl-Glöckner',
  },
  wk217: {
    firstname: 'David',
    lastname: 'Rausch',
  },
  wk218: {
    firstname: 'Sebastian',
    lastname: 'Roloff',
  },
  wk219: {
    firstname: 'Seija',
    lastname: 'Knorr-Köning',
  },
  wk220: {
    firstname: 'Korbinian',
    lastname: 'Rüger',
  },
  wk221: {
    firstname: 'Reka',
    lastname: 'Molnar',
  },
  wk222: {
    firstname: 'Raffael',
    lastname: 'Joos',
  },
  wk223: {
    firstname: 'Carmen',
    lastname: 'Wegge',
  },
  wk224: {
    firstname: 'Dr. Bärbel',
    lastname: 'Kofler',
  },
  wk225: {
    firstname: 'Clemens',
    lastname: 'Meikis',
  },
  wk226: {
    firstname: 'Rita',
    lastname: 'Hagl-Kehl',
  },
  wk227: {
    firstname: 'Anja',
    lastname: 'König',
  },
  wk228: {
    firstname: 'Johannes',
    lastname: 'Schätzl',
  },
  wk229: {
    firstname: 'Severin',
    lastname: 'Eder',
  },
  wk230: {
    firstname: 'Marvin',
    lastname: 'Kliem',
  },
  wk231: {
    firstname: 'David',
    lastname: 'Mandrella',
  },
  wk232: {
    firstname: 'Dr. Carolin',
    lastname: 'Wagner',
  },
  wk233: {
    firstname: 'Marianne',
    lastname: 'Schieder',
  },
  wk234: {
    firstname: 'Gregor',
    lastname: 'Forster',
  },
  wk235: {
    firstname: 'Andreas',
    lastname: 'Schwarz',
  },
  wk236: {
    firstname: 'Anette',
    lastname: 'Kramme',
  },
  wk237: {
    firstname: 'Jonas',
    lastname: 'Eckstein',
  },
  wk238: {
    firstname: 'Jörg',
    lastname: 'Nürnberger',
  },
  wk239: {
    firstname: 'Ali-Cemil',
    lastname: 'Sat',
  },
  wk240: {
    firstname: 'Daniel',
    lastname: 'Mirlach',
  },
  wk241: {
    firstname: 'Martina',
    lastname: 'Stamm-Fibich',
  },
  wk242: {
    firstname: 'Carsten',
    lastname: 'Träger',
  },
  wk243: {
    firstname: 'Gabriela',
    lastname: 'Heinrich',
  },
  wk244: {
    firstname: 'Thomas',
    lastname: 'Grämmer',
  },
  wk245: {
    firstname: 'Jan',
    lastname: 'Plobner',
  },
  wk246: {
    firstname: 'Manuel',
    lastname: 'Michniok',
  },
  wk247: {
    firstname: 'Sabine',
    lastname: 'Dittmar',
  },
  wk248: {
    firstname: 'Bernd',
    lastname: 'Rützel',
  },
  wk249: {
    firstname: 'Markus',
    lastname: 'Hümpfer',
  },
  wk250: {
    firstname: 'Katharina',
    lastname: 'Räth',
  },
  wk251: {
    firstname: 'Ulrike',
    lastname: 'Bahr',
  },
  wk252: {
    firstname: 'Heike',
    lastname: 'Heubach',
  },
  wk253: {
    firstname: 'Christoph',
    lastname: 'Schmid',
  },
  wk254: {
    firstname: 'Andreas',
    lastname: 'Büch',
  },
  wk255: {
    firstname: 'Marcel',
    lastname: 'Keller',
  },
  wk256: {
    firstname: 'Konstantin',
    lastname: 'Plappert',
  },
  wk257: {
    firstname: 'Dr. Regina',
    lastname: 'Renner',
  },
  wk258: {
    firstname: 'Lucia',
    lastname: 'Schanbacher',
  },
  wk259: {
    firstname: 'Dietmar',
    lastname: 'Bulat',
  },
  wk260: {
    firstname: 'Jasmina',
    lastname: 'Hostert',
  },
  wk261: {
    firstname: 'Argyri',
    lastname: 'Paraschaki-Schauer',
  },
  wk262: {
    firstname: 'Nils',
    lastname: 'Schmid',
  },
  wk263: {
    firstname: 'Franziska',
    lastname: 'Blessing',
  },
  wk264: {
    firstname: 'Urs',
    lastname: 'Abelein',
  },
  wk265: {
    firstname: 'Macit',
    lastname: 'Karaahmetoglu',
  },
  wk266: {
    firstname: 'Mario',
    lastname: 'Sickinger',
  },
  wk267: {
    firstname: 'Jens',
    lastname: 'Schäfer',
  },
  wk268: {
    firstname: 'Kevin',
    lastname: 'Leiser',
  },
  wk269: {
    firstname: 'Tim-Luka',
    lastname: 'Schwab',
  },
  wk270: {
    firstname: 'Cornelia',
    lastname: 'True',
  },
  wk271: {
    firstname: 'Parsa',
    lastname: 'Marvi',
  },
  wk272: {
    firstname: 'Assad',
    lastname: 'Hussain',
  },
  wk273: {
    firstname: 'Lukas',
    lastname: 'Hornung',
  },
  wk274: {
    firstname: 'Tim',
    lastname: 'Tugendhat',
  },
  wk275: {
    firstname: 'Isabel',
    lastname: 'Cademartori',
  },
  wk276: {
    firstname: 'Philipp',
    lastname: 'Hensinger',
  },
  wk277: {
    firstname: 'Lars',
    lastname: 'Castellucci',
  },
  wk278: {
    firstname: 'Nezaket',
    lastname: 'Yildirim',
  },
  wk279: {
    firstname: 'Katja',
    lastname: 'Mast',
  },
  wk280: {
    firstname: 'Saskia',
    lastname: 'Esken',
  },
  wk281: {
    firstname: 'Dr. Ludwig',
    lastname: 'Striet',
  },
  wk282: {
    firstname: 'Julian',
    lastname: 'Wiedmann',
  },
  wk283: {
    firstname: 'Johannes',
    lastname: 'Fechner',
  },
  wk284: {
    firstname: 'Dirk',
    lastname: 'Flacke',
  },
  wk285: {
    firstname: 'Mirko',
    lastname: 'Witkowski',
  },
  wk286: {
    firstname: 'Derya',
    lastname: 'Türk-Nachbaur',
  },
  wk287: {
    firstname: 'Dr. Lina',
    lastname: 'Seitzl',
  },
  wk288: {
    firstname: 'Rita',
    lastname: 'Schwarzelühr-Sutter',
  },
  wk289: {
    firstname: 'Sebastian',
    lastname: 'Weigle',
  },
  wk290: {
    firstname: 'Florian',
    lastname: 'Zarnetta',
  },
  wk291: {
    firstname: 'Sebastian',
    lastname: 'Gillmeister',
  },
  wk292: {
    firstname: 'Martin',
    lastname: 'Gerster',
  },
  wk293: {
    firstname: 'Leon',
    lastname: 'Hahn',
  },
  wk294: {
    firstname: 'Heike',
    lastname: 'Engelhardt',
  },
  wk295: {
    firstname: 'Robin',
    lastname: 'Mesarosch',
  },
  wk296: {
    firstname: 'Josephine',
    lastname: 'Ortleb',
  },
  wk297: {
    firstname: 'David',
    lastname: 'Maaß',
  },
  wk298: {
    firstname: 'Christian',
    lastname: 'Petry',
  },
  wk299: {
    firstname: 'Esra',
    lastname: 'Limbacher',
  },
}

export default wahlkreisData
